import { Platform, StyleSheet } from 'react-native';
import { Colors } from '../../../themes';
import { tokens } from '../../crop-circle/tokens';

export const datePickerStyle = StyleSheet.create({
  container: {
    padding: 12,
    backgroundColor: Colors.primaryGrayBackground,
  },
  calendar: {
    backgroundColor: Colors.primaryGrayBackground,
    width: 276,
  },
  dateRangeContainer: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    columnGap: 12,
    paddingBottom: 12,
  },
  dateRangeFieldContainer: {
    flex: 1,
    padding: 8,
    flexDirection: 'column',
    justifyContent: 'flex-start',
    height: 64,
    backgroundColor: Colors.white,
    borderRadius: 6,
    borderWidth: 1,
    borderColor: Colors.grayFill,
    ...Platform.select({
      web: {
        height: 61,
        width: '100%',
        minWidth: '100%',
        maxWidth: '100%',
        boxSizing: 'border-box',
        position: 'relative',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        justifyContent: 'flex-start',
      },
      ios: {},
      android: {},
    }),
  },
  dateRangeFieldContainerActive: {
    opacity: 0.4,
  },
  dateRangeFieldContainerActiveRedesign: {
    borderColor: Colors.blackText,
  },
  labelContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    textAlignVertical: 'center',
    alignItems: 'center',
    marginBottom: 4,
    height: 20,
    ...Platform.select({
      web: {
        minWidth: '100%',
        maxWidth: '100%',
        overflow: 'hidden',
        width: '100%',
        display: 'flex',
      },
      ios: {},
      android: {},
    }),
  },
  label: {
    fontSize: 12,
    fontWeight: '500',
    ...Platform.select({
      web: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        maxWidth: '100%',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
      },
      ios: {},
      android: {},
    }),
  },
  inputContainer: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    ...Platform.select({
      web: {
        minWidth: '100%',
        maxWidth: '100%',
        overflow: 'hidden',
        position: 'relative',
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
      },
      ios: {},
      android: {},
    }),
  },
  inputInnerStyle: {
    paddingLeft: 0,
    paddingRight: 0,
    borderRadius: 0,
    backgroundColor: 'transparent',
    marginRight: 4,
    fontSize: 16,
    fontWeight: '400',
    letterSpacing: -0.25,
    ...Platform.select({
      web: {
        flex: 1,
        minWidth: '100%',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
      },
      android: {
        fontWeight: '300',
        fontSize: 14,
        marginRight: 0,
      },
    }),
  },
  calendarIcon: {
    margin: 0,
    padding: 0,
    width: 16,
    height: 16,
    ...Platform.select({
      web: {
        flexShrink: 0,
        marginLeft: 4,
        position: 'relative',
        zIndex: 1,
        right: 0,
        top: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'row',
        alignSelf: 'center',
      },
      ios: {},
      android: {},
    }),
  },
  inputTouchArea: {
    flex: 1,
  },
  datePickerIcons: {
    position: 'absolute',
    right: 48,
    top: 0,
    bottom: 0,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    zIndex: 10,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 20,
    columnGap: 10,
  },
  buttonHeaderMonth: {
    backgroundColor: Colors.white,
    height: 30,
    minWidth: 78,
    maxWidth: 140,
    borderRadius: 8,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
    alignContent: 'center',
  },
  labelHeader: {
    fontSize: 16,
    fontWeight: '600',
    lineHeight: 16,
    color: Colors.black,
  },
  labelHeaderSelected: {
    color: Colors.primary,
    zIndex: 9,
  },
  textDay: {
    borderRadius: 4,
    width: 28,
    height: 28,
    padding: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  datePickerContainer: {
    height: 52,
    flex: 1,
    borderRadius: 8,
    flexDirection: 'row',
    alignItems: 'center',
    paddingRight: 4,
    paddingLeft: 12,
    marginTop: 8,
    backgroundColor: tokens.colors.neutral[200],
    ...(Platform.OS === 'web' && {
      maxHeight: 52,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      display: 'flex',
      height: 52,
      minHeight: 52,
      overflow: 'visible',
      paddingVertical: 0,
      position: 'relative',
    }),
  },
  calendarIconStyle: {
    margin: 0,
    padding: 0,
    ...(Platform.OS === 'web' && {
      alignSelf: 'center',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }),
  },
  dateDisplayContainer: {
    flex: 1,
    justifyContent: 'center',
  },
  dateText: {
    fontSize: 16,
    fontWeight: '400',
    color: Colors.grayText,
  },
  timeContainerCropCircle: {
    padding: 8,
    paddingLeft: 12,
    backgroundColor: tokens.colors.neutral[200],
    borderRadius: 8,
  },
});
